"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var generateRoutes_exports = {};
__export(generateRoutes_exports, {
  run: () => run
});
module.exports = __toCommonJS(generateRoutes_exports);
var import_fs = require("fs");
var import_path = require("path");
var import_generateRouteTypes = require("../typed-routes/generateRouteTypes");
var import_getRouterRootFromOneOptions = require("../utils/getRouterRootFromOneOptions");
var import_loadConfig = require("../vite/loadConfig");
async function run() {
  var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var cwd = process.cwd();
  var oneOptions;
  var routerRoot;
  var ignoredRouteFiles;
  try {
    var originalStderrWrite = process.stderr.write;
    var stderrBuffer = "";
    process.stderr.write = function(chunk) {
      stderrBuffer += chunk;
      return true;
    };
    try {
      var _oneOptions_router;
      var loaded = await (0, import_loadConfig.loadUserOneOptions)("build");
      oneOptions = loaded.oneOptions;
      routerRoot = args.appDir || (0, import_getRouterRootFromOneOptions.getRouterRootFromOneOptions)(oneOptions);
      ignoredRouteFiles = (_oneOptions_router = oneOptions.router) === null || _oneOptions_router === void 0 ? void 0 : _oneOptions_router.ignoredRouteFiles;
    } finally {
      process.stderr.write = originalStderrWrite;
    }
  } catch (error) {
    routerRoot = args.appDir || "app";
  }
  var appDir = (0, import_path.join)(cwd, routerRoot);
  if (!(0, import_fs.existsSync)(appDir)) {
    console.error(`Error: App directory not found at ${appDir}`);
    console.error("You can specify a custom directory with: npx one generate-routes --appDir=<path>");
    process.exit(1);
  }
  var outFile = (0, import_path.join)(appDir, "routes.d.ts");
  var typedRoutesMode;
  if (args.typed) {
    if (args.typed === "type" || args.typed === "runtime") {
      typedRoutesMode = args.typed;
    } else {
      console.error(`Error: Invalid --typed value "${args.typed}". Must be "type" or "runtime"`);
      process.exit(1);
    }
  } else if (oneOptions) {
    var _oneOptions_router_experimental, _oneOptions_router1;
    typedRoutesMode = ((_oneOptions_router1 = oneOptions.router) === null || _oneOptions_router1 === void 0 ? void 0 : (_oneOptions_router_experimental = _oneOptions_router1.experimental) === null || _oneOptions_router_experimental === void 0 ? void 0 : _oneOptions_router_experimental.typedRoutesGeneration) || void 0;
  }
  if (typedRoutesMode) {
  } else if (!args.typed) {
  }
  await (0, import_generateRouteTypes.generateRouteTypes)(outFile, routerRoot, ignoredRouteFiles, typedRoutesMode);
  if (typedRoutesMode) {
  }
}
//# sourceMappingURL=generateRoutes.js.map
